import { AnimatedBackground, LogoThemeAware } from '../atomic-atoms';
import { Link } from '../atomic-atoms';
import { ThemeToggle } from '../atomic-molecules';

import styles from './BrandLandingShell.module.scss';

type BrandLandingLayoutProps = {
  children: React.ReactNode;
  brandSlot?: React.ReactNode;
  actionsSlot?: React.ReactNode;
  className?: string;
  footerLinks?: readonly {
    href: string;
    label: string;
  }[];
};

export function BrandLandingShell({
  children,
  brandSlot = <LogoThemeAware forceTheme="dark" />,
  actionsSlot = <ThemeToggle />,
  className,
  footerLinks,
}: BrandLandingLayoutProps) {
  return (
    <div className={styles.shell}>
      <AnimatedBackground />

      <main className={`${styles.page} ${className}`}>
        <div className={styles.grid} aria-hidden />
        <div className={styles.brand}>{brandSlot}</div>
        <div className={styles.themeToggle}>{actionsSlot}</div>

        {children}

        <p className={styles.footer}>
          Net Net is workflow management software, built to measure performance
          to make profitability more predictable.&nbsp; Learn more at&nbsp;
          <Link
            href="https://hellonetnet.com"
            ariaLabel="Learn more at"
            target="_blank"
          >
            hellonetnet.com
          </Link>
          {footerLinks?.length ? (
            <nav className={styles.footerLinks} aria-label="Legal links">
              {footerLinks.map((link) => (
                <Link key={link.href} href={link.href} ariaLabel={link.label}>
                  {link.label}
                </Link>
              ))}
            </nav>
          ) : null}
        </p>
      </main>
    </div>
  );
}
